var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5999 55.5L35.7899 43.6425C34.1624 42.48 31.8374 42.48 30.2099 43.6425L14.3999 55.5V13.65C14.3999 11.0925 16.4924 9 19.0499 9H46.9499C49.5074 9 51.5999 11.0925 51.5999 13.65V55.5Z",
    fill: "#DDEDDA",
    stroke: "#56A748",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.049 15.2093C32.3483 14.288 33.6517 14.288 33.9511 15.2093L35.7232 20.6634C35.8571 21.0755 36.2411 21.3544 36.6743 21.3544H42.4091C43.3779 21.3544 43.7806 22.594 42.9969 23.1634L38.3573 26.5343C38.0069 26.7889 37.8602 27.2403 37.9941 27.6523L39.7662 33.1065C40.0656 34.0278 39.0111 34.7939 38.2274 34.2245L33.5878 30.8537C33.2373 30.599 32.7627 30.599 32.4122 30.8537L27.7726 34.2245C26.9889 34.7939 25.9344 34.0278 26.2338 33.1065L28.006 27.6523C28.1398 27.2403 27.9932 26.7889 27.6427 26.5343L23.0031 23.1634C22.2194 22.594 22.6222 21.3544 23.5909 21.3544H29.3257C29.759 21.3544 30.1429 21.0755 30.2768 20.6634L32.049 15.2093Z",
    fill: "#91C688",
    stroke: "#56A748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.50d8bff3.svg";
export { ForwardRef as ReactComponent };